module.exports = __webpack_public_path__ + "static/media/cp-step-2.6d2ef616.png";